// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"cb1eb0c9","580":"4f9f5848","641":"37a463c6","798":"1cb5ca58"}[chunkId] + ".chunk.js";
};